import React from 'react';
import {useIntl} from 'react-intl';
import {AdminNewsFormValues, NewsSchema} from '../Types/news';
import AdminNewsForm from './AdminNewsForm';
import FormModal from '../../../Components/FormModal';
import {FormikProps, useFormik} from 'formik';
import {useUpdateNews} from '../Hooks/NewsHooks';
import {News} from '../Types/type';

interface UpdateNewsProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  news: News;
}

const UpdateNewsModal = ({showModal, setShowModal, news}: UpdateNewsProps) => {
  const intl = useIntl();

  const {mutate} = useUpdateNews();

  const formik: FormikProps<AdminNewsFormValues> = useFormik({
    initialValues: {
      category_id: news.category.id,
      start_date: news.startDate ?? '',
      end_date: news.endDate ?? '',
      moreType: news.news != null ? 'url' : 'none',
      news: news.news ?? '',
      title: news.title,
      description: news.description ?? '',
      type: news.type ?? 'encart',
      frequency: news.frequency ?? 'session',
    },
    enableReinitialize: true, //Permet de reinit les valeurs quand on change de news
    validationSchema: NewsSchema(intl),
    validateOnChange: true,
    onSubmit: async (values: AdminNewsFormValues) => {
      mutate(
        {...values, id: news.id},
        {
          onSuccess: () => {
            setShowModal(false);
          },
        }
      );
    },
  });

  return (
    <FormModal
      title={'Nouvelle news'}
      show={showModal}
      onHide={() => {
        setShowModal(false);
      }}
      size="lg"
      disable={formik.isSubmitting || !formik.isValid}
      onSubmit={() => formik.submitForm()}
    >
      <AdminNewsForm formik={formik} />
    </FormModal>
  );
};

export default UpdateNewsModal;
